export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/intro-bg.c3a312ef-8ad496.png";